<template>
  <div class="tff-container-search">
    <v-layout row pb-2>
      <v-flex xs12 md8 offset-md2 px-1>
        <v-card class="hc__rounded-card">
          <v-card-title class="text-xs-center">
            <v-flex>
              <h1 class="blue-security display-1">Centro de Ayuda</h1>
            </v-flex>
          </v-card-title>

          <v-card-text>
            <form @submit.prevent="">
              <v-text-field
                v-model="search"
                label="¿En qué te ayudamos?"
                required
                outline
                class="tff-search-input-hc"
                color="#1B0088"
                @keyup="searchTimeOut()"
              ></v-text-field>
            </form>

            <v-progress-linear :indeterminate="true" color="success" v-show="isLoading"></v-progress-linear>

            <v-list v-for="(result, i) in results" :key="i"> 
              <v-list-tile
                :key="i"
                :to="`${result.url}`"
              >
                <v-list-tile-content>
                  <v-list-tile-title v-text="result.name"></v-list-tile-title>
                </v-list-tile-content>

                <v-list-tile-action>
                  <v-icon color="info">arrow_forward_ios</v-icon>
                </v-list-tile-action>
              </v-list-tile>
              
              <v-divider></v-divider>
            </v-list>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import { mapActions } from 'vuex'

export default {
  data: () => ({
    isLoading: false,
    search: "",
    results: [],
    timer: null
  }),
  methods: {
    ...mapActions("helpcenter", ["fetchSearch"]),
    async handleSearch() {
      if (this.search.length < 4) {
        this.results = []
        return
      }
      
      const res = await this.fetchSearch(this.search)
      this.results = res
    },
    searchTimeOut() {
      this.isLoading = true
      if (this.timer) {
        clearTimeout(this.timer)
        this.timer = null
      }
      this.timer = setTimeout(() => {
        this.handleSearch()
        this.isLoading = false
      }, 800)
    }
  },
}
</script>
<style lang="css">
.tff-container-search {
  position: relative;
  width: 100%;
  padding: 2.5rem 0px 6rem;
  border-radius: 0px 0px 1.5rem 1.5rem;
  background: url(https://assets-intranet-security.s3.us-east-2.amazonaws.com/helpcenter_background.jpg) center center / cover no-repeat;
}

.tff-search-input-hc.theme--light.v-text-field--outline:not(.v-input--is-focused):not(.v-input--has-state) > .v-input__control > .v-input__slot:hover {
    border: 2px solid #1B0088;
}

@media (max-width: 959px) {
  .tff-container-search {
    background: none;
    padding: 0px;
  }
}
</style>